/**
 * Engraving Section — Luxury Jewelry
 * Vanilla JS only. No jQuery. No Bootstrap.
 * Cart add via fetch-intercept for reliability.
 */
(function () {
  'use strict';

  // ── State (module-level so fetch interceptor can read it) ─────────────
  var engravingState = {
    text: '',
    font: 'Classic',
    size: 'Small',
    active: false,
    mode: 'free',
    serviceVariantId: null,
    serviceHandle: 'engraving-service',
    addingService: false   // guard against double-add
  };

  // ── Fetch interceptor — runs immediately, before DOM ready ────────────
  // Wraps window.fetch so we can react to /cart/add.js completions.
  (function installFetchInterceptor() {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var isCartAdd = /\/cart\/add(\.js)?/.test(url);
      var promise = _fetch.apply(this, arguments);

      if (isCartAdd) {
        promise.then(function (response) {
          // Clone so original consumer still gets a readable body
          var cloned = response.clone();
          cloned.json().then(function (data) {
            // data.id exists on success; data.status exists on error
            if (data && !data.status && engravingState.active &&
                engravingState.mode === 'paid' &&
                engravingState.serviceVariantId &&
                !engravingState.addingService) {

              // Make sure this isn't already the service product being added
              var addedVariantId = data.variant_id || (data.items && data.items[0] && data.items[0].variant_id);
              if (String(addedVariantId) === String(engravingState.serviceVariantId)) return;

              engravingState.addingService = true;
              addEngravingService()
                .catch(function (e) { console.warn('[Engraving] service add error:', e); })
                .finally(function () { engravingState.addingService = false; });
            }
          }).catch(function () {});
          return response;
        });
      }

      return promise;
    };
  })();

  function addEngravingService() {
    var cartEl = document.querySelector('ajax-cart');
    var sections = cartEl
      ? cartEl.fetchSecToInclude().map(function (s) { return s.id; })
      : ['ajax-cart', 'ajax-cart-icon'];

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        id: engravingState.serviceVariantId,
        quantity: 1,
        properties: {
          'Engraving Text': engravingState.text,
          'Font': engravingState.font,
          'Size': engravingState.size
        },
        sections: sections,
        sections_url: window.location.pathname
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (response) {
      if (!response || response.status) return response; // error, skip refresh

      if (cartEl && response.sections) {
        // Primary path: pass sections data to the cart drawer's own renderContents
        cartEl.renderContents(response);
      } else {
        // Fallback: re-fetch both sections manually
        var p1 = fetch(window.location.pathname + '?section_id=ajax-cart')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var freshDrawer = parsed.querySelector('#ajaxcart');
            var liveDrawer  = document.getElementById('ajaxcart');
            if (freshDrawer && liveDrawer) {
              liveDrawer.innerHTML = freshDrawer.innerHTML;
              var overlay = liveDrawer.querySelector('#ajaxcart-overlay');
              if (overlay && cartEl) overlay.addEventListener('click', cartEl.close.bind(cartEl));
            }
          });
        var p2 = fetch(window.location.pathname + '?section_id=ajax-cart-icon')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parsed   = new DOMParser().parseFromString(html, 'text/html');
            var fresh    = parsed.querySelector('.shopify-section');
            var liveIcon = document.getElementById('ajax-cart-icon');
            if (fresh && liveIcon) liveIcon.innerHTML = fresh.innerHTML;
          });
        Promise.all([p1, p2]).catch(function () {});
      }
      return response;
    });
  }

  // ── DOM init ──────────────────────────────────────────────────────────
  function initEngraving() {
    var section = document.getElementById('engraving-section');
    if (!section) return;

    engravingState.mode          = section.dataset.mode || 'free';
    engravingState.serviceHandle = section.dataset.serviceHandle || 'engraving-service';
    var maxChars = parseInt(section.dataset.maxChars) || 12;

    var toggleBtn  = document.getElementById('engraving-toggle-btn');
    var fontCards  = section.querySelectorAll('.font-card');
    var sizeOpts   = section.querySelectorAll('.size-option');
    var textInput  = document.getElementById('engraving-text-input');
    var previewEl  = document.getElementById('engraving-preview-text');
    var charInline = section.querySelector('.char-counter-inline');
    var charRight  = section.querySelector('.char-counter-right');
    var propText   = document.getElementById('engraving-prop-text');
    var propFont   = document.getElementById('engraving-prop-font');
    var propSize   = document.getElementById('engraving-prop-size');
    var propActive = document.getElementById('engraving-prop-active');

    // ── Collapse / Expand ───────────────────────────────────────────────
    function toggleCollapse() {
      var open = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!open));
      section.classList.toggle('collapsed', open);
    }
    toggleBtn.addEventListener('click', toggleCollapse);
    toggleBtn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleCollapse(); }
    });

    // ── Font ────────────────────────────────────────────────────────────
    fontCards.forEach(function (card) {
      card.addEventListener('click', function () { selectFont(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectFont(card); }
      });
    });

    function selectFont(card) {
      fontCards.forEach(function (c) {
        c.classList.remove('selected');
        c.setAttribute('aria-checked', 'false');
      });
      card.classList.add('selected');
      card.setAttribute('aria-checked', 'true');
      card.querySelector('input[type=radio]').checked = true;
      engravingState.font = card.dataset.font;
      previewEl.classList.remove('font-classic', 'font-italic', 'font-cursive');
      var fontMap = { Classic: 'font-classic', Italic: 'font-italic', Cursive: 'font-cursive' };
      previewEl.classList.add(fontMap[engravingState.font] || 'font-classic');
      syncProps();
    }

    // ── Size ────────────────────────────────────────────────────────────
    sizeOpts.forEach(function (opt) {
      opt.addEventListener('click', function () { selectSize(opt); });
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectSize(opt); }
      });
    });

    function selectSize(opt) {
      sizeOpts.forEach(function (o) {
        o.classList.remove('selected');
        o.setAttribute('aria-checked', 'false');
      });
      opt.classList.add('selected');
      opt.setAttribute('aria-checked', 'true');
      opt.querySelector('input[type=radio]').checked = true;
      engravingState.size = sizeLabel(opt.dataset.size);
      previewEl.classList.remove('size-S', 'size-M', 'size-L');
      previewEl.classList.add('size-' + opt.dataset.size);
      syncProps();
    }

    // ── Text ────────────────────────────────────────────────────────────
    textInput.addEventListener('input', function () {
      engravingState.text = textInput.value.slice(0, maxChars);
      if (textInput.value !== engravingState.text) textInput.value = engravingState.text;
      var count = engravingState.text.length;
      var label = count + '/' + maxChars;
      if (charInline) charInline.textContent = '(' + label + ')';
      if (charRight)  charRight.textContent  = label;
      previewEl.textContent = engravingState.text || (window.__engravingDefaultText || 'Example');
      syncProps();
    });

    function syncProps() {
      engravingState.active = engravingState.text.trim().length > 0;
      if (propText)   propText.value   = engravingState.text;
      if (propFont)   propFont.value   = engravingState.font;
      if (propSize)   propSize.value   = engravingState.size;
      if (propActive) propActive.value = String(engravingState.active);
    }

    function sizeLabel(s) {
      return { S: 'Small', M: 'Medium', L: 'Large' }[s] || s;
    }

    // ── Fetch service variant ID ─────────────────────────────────────────
    if (engravingState.mode === 'paid') {
      fetch('/products/' + engravingState.serviceHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.variants && data.variants[0]) {
            engravingState.serviceVariantId = data.variants[0].id;
          } else {
            console.warn('[Engraving] Service product "' + engravingState.serviceHandle + '" not found. Create it in Shopify Admin.');
          }
        })
        .catch(function () {
          console.warn('[Engraving] Could not fetch service product.');
        });
    }

    // ── Remove service if engraved item removed from cart ────────────────
    // Watch for cart quantity changes via MutationObserver on cart containers
    function watchCartForRemoval() {
      var targets = [
        document.getElementById('ajaxcart-cartitems'),
        document.querySelector('.js-contents'),
        document.querySelector('#cart-section .js-contents')
      ].filter(Boolean);

      if (!targets.length) return;

      var observer = new MutationObserver(function () {
        if (engravingState.mode !== 'paid' || !engravingState.serviceVariantId) return;
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var hasEngraved = cart.items.some(function (item) {
              return item.properties &&
                     item.properties['Engraving Text'] &&
                     item.properties['Engraving Text'].trim() !== '';
            });
            var serviceItem = cart.items.find(function (item) {
              return String(item.variant_id) === String(engravingState.serviceVariantId);
            });
            if (!hasEngraved && serviceItem) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: engravingState.serviceVariantId, quantity: 0 })
              }).catch(function () {});
            }
          });
      });

      targets.forEach(function (t) {
        observer.observe(t, { childList: true, subtree: true });
      });
    }

    watchCartForRemoval();

    // ── Init defaults ───────────────────────────────────────────────────
    syncProps();
    previewEl.classList.add('font-classic', 'size-S');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEngraving);
  } else {
    initEngraving();
  }
})();
